// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddPhoneNumberForm-phoneNumberCheckBox-vQVvt {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    gap: 8px;
}

.AddPhoneNumberForm-indicationTxt-S0los {
    font-size: 16px;
    line-height: normal;
    margin: 0;
}

.AddPhoneNumberForm-indicationTxt-S0los a,
.AddPhoneNumberForm-indicationTxt-S0los a:hover,
.AddPhoneNumberForm-indicationTxt-S0los a:focus {
    color: var(--common-link-color);
}`, "",{"version":3,"sources":["webpack://./src/components/PhoneVerificationModal/AddPhoneNumberForm/AddPhoneNumberForm.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,SAAS;AACb;;AAEA;;;IAGI,+BAA+B;AACnC","sourcesContent":[".phoneNumberCheckBox {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n}\n\n.indicationTxt {\n    font-size: 16px;\n    line-height: normal;\n    margin: 0;\n}\n\n.indicationTxt a,\n.indicationTxt a:hover,\n.indicationTxt a:focus {\n    color: var(--common-link-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"phoneNumberCheckBox": `AddPhoneNumberForm-phoneNumberCheckBox-vQVvt`,
	"indicationTxt": `AddPhoneNumberForm-indicationTxt-S0los`
};
module.exports = ___CSS_LOADER_EXPORT___;
